import React, { Component } from "react";
import { connect } from "react-redux";
import { commonLocalization } from "../../../localization";
import { projectTypesData } from "../../../config/localProjects";

class FilterTags extends Component {
  render() {
    const { filters } = this.props;
    const {
      search,
      page,
      sort_by,
      order_by,
      "fiscal-year": year,
      ...appliedFilters
    } = filters;

    return <div className='tags-wrap'>{this.renderTags(appliedFilters)}</div>;
  }

  renderTags(filters) {
    return Object.keys(filters).map((key) => {
      if (!filters[key]) return null;

      return (
        <div key={"tags-" + key} className='tags'>
          <span>
            {this.getTitleFromKey(key) +
              this.getLocalizationValue(key, filters[key])}
          </span>
          <span
            className='remove-keyword'
            onClick={() => this.props.removeFilter(key)}
          />
        </div>
      );
    });
  }

  getLocalizationValue(key, value) {
    const language = window.language;
    const localizationCommon = commonLocalization[language];

    if (key === "status") {
      switch (value) {
        case "submitted":
          return localizationCommon.submitted;
        case "evaluated":
          return localizationCommon.evaluated;
        default:
          return "";
      }
    }

    if (key === "ward") {
      return value;
    }

    if (key === "type") {
      const projectType = projectTypesData.find((type) => type.value === value);
      return projectType
        ? language === "np"
          ? projectType.title_ne
          : projectType.title_en
        : value;
    }

    return value;
  }

  getTitleFromKey(key) {
    const language = window.language;
    switch (key) {
      case "ward":
        return language === "en" ? "Ward: " : "वडा: ";
      default:
        return "";
    }
  }
}

export default connect()(FilterTags);



// WEBPACK FOOTER //
// ./src/pages/localProject/list/filterTags.js